import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateUtilities, isDefined, ModalClass, NotificationHistoryModel } from '@evorait/pace-core';
import { faChevronDown, faChevronUp, faCloudUploadAlt, faSave } from '@fortawesome/free-solid-svg-icons';
import { BsModalService } from 'ngx-bootstrap/modal';
import { initialDocumentState, UploadModalComponent } from '@evorait/pace-forms';
import moment from 'moment';
import { take } from 'rxjs/operators';
import { getMappedHistoryToNotification } from '../../docbox-tabbed-modal.utilities';
import { Store } from '@ngrx/store';
import { downloadDocuments } from 'libs/pace-forms/src/lib/store/actions/docBox.action';

@Component({
    selector: 'pace-docbox-notification-history-detail',
    templateUrl: './notification-history-detail.component.html',
    styleUrls: ['./notification-history-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DocBoxNotificationHistoryDetailComponent implements OnInit {
    @Input() public notifications: NotificationHistoryModel[];
    @Output() public refresh = new EventEmitter<void>();

    public system: string;
    public readonly faChevronDown = faChevronDown;
    public readonly faChevronUp = faChevronUp;
    public readonly faSave = faSave;
    public readonly faCloudUpload = faCloudUploadAlt;
    public isCollapsed = true;
    public group = {
        description: '',
        customerName: '',
        endDate: moment(),
        notificationNumber: '',
    };

    public constructor(
        private readonly modalService: BsModalService,
        private readonly store: Store,
    ) {}

    public ngOnInit(): void {
        this.group.description = this.notifications[0].description;
        this.group.customerName = this.notifications[0].completeName;
        this.group.endDate = this.notifications[0].endDate;
        this.group.notificationNumber = this.notifications[0].notificationNumber;
    }

    public formatDate(date: moment.Moment): string {
        return DateUtilities.formatDate(date);
    }

    public get docBoxIds(): string[] {
        return this.notifications?.map((n) => n.docBoxId);
    }

    public downloadDocuments(docBoxIds: string[]): void {
        this.store.dispatch(downloadDocuments({ docBoxIds }));
    }

    public uploadDocument(): void {
        const modalInstance = this.modalService.show(UploadModalComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_MEDIUM,
            initialState: {
                docBoxModel: { ...initialDocumentState },
                // Taking the first entry because they all contain the same data
                notification: getMappedHistoryToNotification(this.notifications[0]),
            },
            ariaLabelledBy: 'upload-modal-title',
        });
        modalInstance.content?.modalResult.pipe(take(1)).subscribe((response) => {
            if (isDefined(response)) {
                this.refreshData();
            }
        });
    }

    public refreshData(): void {
        this.refresh.emit();
    }
}
